import { t } from "ttag";

import { useEditSessionContext } from "@/features/coaching/context";
import { SessionFields } from "@/features/coaching/sections";
import { Card } from "@/shared/ui";

export const EditSessionForm = () => {
  const { form } = useEditSessionContext();

  return (
    <Card.Root className="p-6">
      <Card.Title>{t`Main info`} </Card.Title>
      <Card.Content className="grid gap-x-4 gap-y-0.5 md:grid-cols-2">
        <SessionFields form={form} />
      </Card.Content>
    </Card.Root>
  );
};
